import React, { useState, useEffect } from "react";
import { useLang } from "@/context/LanguageContext";
import { api, API_BASE } from "@/lib/api";

const STOCK = [
  { src: "https://images.unsplash.com/photo-1503694978374-8a2fa686963a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", label: "Flex Banner" },
  { src: "https://images.unsplash.com/photo-1571217748526-261477b6ac62?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", label: "Storefront Signage" },
  { src: "https://images.pexels.com/photos/5549643/pexels-photo-5549643.jpeg?auto=compress&cs=tinysrgb&w=800", label: "LED Name Board" },
  { src: "https://images.unsplash.com/photo-1693031630146-568e2f72db0e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", label: "Vinyl Branding" },
  { src: "https://images.unsplash.com/photo-1693031630369-bd429a57f115?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", label: "Large Format" },
  { src: "https://images.unsplash.com/photo-1741769971460-aad286ffe96b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", label: "Bengaluru Shopfront" },
];

export const Gallery = () => {
  const { lang, tr } = useLang();
  const kn = lang === "kn";
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/gallery")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  const usingReal = items && items.length > 0;
  const display = usingReal
    ? items.map((it) => ({ src: `${API_BASE}/gallery/${it.id}/image`, label: it.caption || "Creative Prints" }))
    : STOCK;

  return (
    <section id="gallery" className="py-16 lg:py-24 bg-slate-900">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className={`text-xs font-bold uppercase tracking-widest text-amber-400 ${kn ? "font-kn" : ""}`}>{tr("gallery_kicker")}</p>
          <h2 className={`mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white ${kn ? "font-kn" : "font-heading"}`}>{tr("gallery_title")}</h2>
        </div>
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-4">
          {display.map((g, i) => (
            <div key={i} data-testid={`gallery-item-${i}`} className="group relative overflow-hidden rounded-xl bg-slate-800">
              <img src={g.src} alt={g.label} loading="lazy" className="h-44 sm:h-56 w-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <span className="text-sm font-semibold text-white">{g.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
